/*
 * Read-only display of rich-text content via <TextEditor readOnly>. The CL editor is styled as an
 * editing field (elevated surface, 20px padding, 172px min-height, CL typography); for inline
 * read-only display we strip that chrome and render with the viewer's theme tokens.
 * (min-height is handled by the minHeight={0} prop.)
 */
.richText {
  /* Drop the editor surface; scoped to this subtree only. */
  --mi-background-elevate: transparent;
}

.richText [role='textbox'] {
  padding: 0;
  font: var(--400-14);
  font-family: var(--textFont);
  color: rgb(var(--textFontColor));
}

.richText [role='textbox'] a {
  color: rgb(var(--primaryColor));
}
